module.exports = __webpack_public_path__ + "static/img/dreamWearNasalMask.cf3b499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/dreamWearNasalMask.png
// module id = HCf/
// module chunks = 1